import React from "react";
import DemographicsModule from "./DemographicsModule";
import DemographicsSagas from "./redux/DemographicsSagas";
import DemographicsReducer from "./redux/DemographicsReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Demographics",
  moduleList: [
    {
      Component: DemographicsModule,
      moduleName: "demographics",
      saga: DemographicsSagas(),
      reducer: DemographicsReducer
    }
  ],
  hideConfigurator: true
};

const DemographicsPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default DemographicsPage;
